import React from 'react';

import SlideOne from '../imagens/slide5.jpg';
import SlideTwo from '../imagens/slide4.jpg';

class Slide extends React.Component {
    render(){
        return(
        <div>
            <div id="carouselExampleControls" className="carousel slide" data-ride="carousel">
                <div className="carousel-inner">
                    <div className="carousel-item active">
                        <img className="d-block w-100 fullMobile" src={SlideOne} alt="Primeiro Slide"></img>
                    </div>
                    <div className="carousel-item">
                        <img className="d-block w-100 fullMobile" src={SlideTwo} alt="Segundo Slide"></img>
                    </div>
                </div>
                <a className="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="sr-only">Anterior</span>
                </a>
                <a className="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="sr-only">Próximo</span>
                </a>
                </div>
            <div className="separator1"></div>
            </div>
        )
    }
}

export default Slide;